import { Checkbox, List, ListItem, ListItemIcon, ListItemText, Typography } from "@material-ui/core";
import { useState } from "react";
import { UserItem, UserListProps } from "./UserListProps";
import { userListStyles } from "./UserListStyles";

export default function UserList(props: UserListProps) {
    const classes = userListStyles();
    const [selectedUsers, setSelectedUsers] = useState<UserItem[]>([]);

    const handleToggle = (user: UserItem) => () => {
        const currentIndex = selectedUsers.indexOf(user);
        const newSelectedUsers = [...selectedUsers];

        if (currentIndex === -1) {
            newSelectedUsers.push(user);
        } else {
            newSelectedUsers.splice(currentIndex, 1);
        }

        setSelectedUsers(newSelectedUsers);
        props.onSelectionChange(newSelectedUsers);
    };

    return (
        <div>
            <Typography gutterBottom>Users</Typography>
            <List className={classes.list}>
                {props.users.map((x) => {
                    const labelId = `checkbox-list-label-${x.id}`;

                    return (
                        <ListItem key={x.id} button onClick={handleToggle(x)} className={classes.listItem}>
                            <ListItemIcon>
                                <Checkbox
                                    edge="start"
                                    checked={selectedUsers.indexOf(x) !== -1}
                                    tabIndex={-1}
                                    disableRipple
                                    inputProps={{ "aria-labelledby": labelId }}
                                />
                            </ListItemIcon>
                            <ListItemText id={labelId} primary={x.email} />
                        </ListItem>
                    );
                })}
            </List>
        </div>
    );
}
